import { render, staticRenderFns } from "./StudyMenu.vue?vue&type=template&id=e5c43e08&scoped=true&lang=pug"
import script from "./StudyMenu.vue?vue&type=script&lang=ts"
export * from "./StudyMenu.vue?vue&type=script&lang=ts"
import style0 from "./StudyMenu.vue?vue&type=style&index=0&id=e5c43e08&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c43e08",
  null
  
)

export default component.exports